import { memo } from 'react';
import Box from '@mui/material/Box';
import MuiSkeleton from '@mui/material/Skeleton';
import { ICmnSkeletonProps } from 'interface/cmn/commonInfo';

function TableBodySkeleton({ justifyContent = 'center', width, height, ...others }: ICmnSkeletonProps): JSX.Element {
  return (
    <Box sx={{ display: 'flex', justifyContent }}>
      <MuiSkeleton sx={{ width: width ?? 120, height: height ?? 33 }} {...others} />
    </Box>
  );
}

export default memo(TableBodySkeleton);
